// src/components/molecules/table/DiscontinuedToggleButton.tsx
import { ReactElement, useMemo } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { getNestedValue } from 'src/utils/settings';

type DiscontinuedToggleButtonProps = {
  settings: any;
  setSetting: (key: any, value: any) => void;

  tableName: string;
  icon: ReactElement;

  tooltipOn?: string;
  tooltipOff?: string;

  onColor?: string;
  offColor?: string;
};

const SETTING_KEY = "IncludeDiscontinued";

const DiscontinuedToggleButton = ({
  settings,
  setSetting,
  tableName,
  icon,
  tooltipOn = "Hide discontinued",
  tooltipOff = "Show discontinued",
  onColor = 'error.main',
  offColor = 'text.disabled',
}: DiscontinuedToggleButtonProps) => {
  const keyPath = useMemo(() => [SETTING_KEY, tableName], [tableName]);

  const isOn = useMemo(() => {
    return getNestedValue(settings, keyPath, false);
  }, [settings, keyPath]);

  return (
    <Tooltip title={isOn ? tooltipOn : tooltipOff}>
      <IconButton
        onClick={() => setSetting(keyPath, !isOn)}
        size="large"
        sx={{
          color: isOn ? onColor : offColor,
          transition: 'color 0.2s ease',
        }}
      >
        {icon}
      </IconButton>
    </Tooltip>
  );
};

export default DiscontinuedToggleButton;
